import Meet from '@/Models/Meet.js';
import ResultCategory from '@/Models/ResultCategory.js';

export default {
    props: {
        meet: {
            type: Meet,
            required: true,
        },

        results: {
            type: Array,
            required: true,
        },

        resultCategory: {
            type: ResultCategory,
            required: true,
        },

        round: {
            type: String,
            required: true,
        },
    },

    data: () => ({
        resultHeaders: [],
        synchroAthleteHeaders: [],
        trampolineHeaders: [],
        doubleMiniHeaders: [],
        tumblingHeaders: [],
        synchroHeaders: [],
    }),

    computed: {
        resultsForRound() {
            return this.results.filter(result => result[`${this.round}_score`] !== null);
        },

        isCumulative() {
            if (this.resultCategory.is_elite && !this.meet.elite_new_life_finals) {
                return true;
            }

            if (!this.resultCategory.is_elite && !this.meet.jo_new_life_finals) {
                return true;
            }

            return false;
        },

        isAdmin() {
            return _.get(this.$page, 'auth.user.id') === 1;
        },

        isAFinalRound() {
            return (
                this.round === 'semi_final' ||
                this.round === 'finals' ||
                this.round === 'final_one' ||
                this.round === 'final_two'
            );
        },

        debugMode() {
            return this.$store.state.debugMode;
        },
    },

    watch: {
        debugMode() {
            this.loadHeaders();
        },
    },

    created() {
        this.loadHeaders();
    },

    methods: {
        loadHeaders() {
            if (this.resultCategory.event === 'TI') {
                this.resultHeaders = [...this.loadAthleteHeaders(), ...this.loadTrampolineHeaders()];
            }

            if (this.resultCategory.event === 'DM') {
                this.resultHeaders = [...this.loadAthleteHeaders(), ...this.loadDoubleMiniHeaders()];
            }

            if (this.resultCategory.event === 'TU') {
                this.resultHeaders = [...this.loadAthleteHeaders(), ...this.loadTumblingHeaders()];
            }

            if (this.resultCategory.event === 'TS') {
                this.resultHeaders = [...this.loadSynchroAthleteHeaders(), ...this.loadSynchroHeaders()];
            }

            if (this.resultCategory.event === 'AA') {
                this.resultHeaders = [...this.loadAthleteHeaders(), ...this.loadAllAroundHeaders()];
            }
        },

        loadAthleteHeaders() {
            const athleteHeaders = [
                {
                    text: '',
                    value: 'image',
                },
                {
                    text: 'Name',
                    value: 'athlete.name',
                },
                {
                    text: this.meet.is_international ? 'Country' : 'Club',
                    value: 'club.name',
                },
            ];

            if (this.$store.state.debugMode) {
                return [
                    ...athleteHeaders,
                    {
                        text: 'ID',
                        value: 'routine_id',
                    },
                ];
            }

            return athleteHeaders;
        },

        loadSynchroAthleteHeaders() {
            return [
                {
                    text: '',
                    value: 'synchro_images',
                },
                {
                    text: 'Pair',
                    value: 'synchro_pair',
                },
                {
                    text: this.meet.is_international ? 'Country' : 'Clubs',
                    value: 'synchro_clubs',
                },
            ];
        },

        loadTrampolineHeaders() {
            return [
                {
                    text: '#',
                    value: 'num',
                },
                {
                    text: 'Execution',
                    value: 'execution',
                },
                {
                    text: 'HD',
                    value: 'hd',
                },
                {
                    text: 'ToF',
                    value: 'tof',
                },
                {
                    text: 'DD',
                    value: 'dd',
                },
                {
                    text: 'ND',
                    value: 'nd',
                    align: 'end',
                },
                {
                    text: 'Score',
                    value: 'score',
                },
            ];
        },

        loadDoubleMiniHeaders() {
            return [
                {
                    text: '#',
                    value: 'num',
                },
                {
                    text: 'Execution',
                    value: 'execution',
                },
                {
                    text: 'DD',
                    value: 'dd',
                },
                {
                    text: 'ND',
                    value: 'nd',
                    align: 'end',
                },
                {
                    text: 'Score',
                    value: 'score',
                },
            ];
        },

        loadTumblingHeaders() {
            return this.loadDoubleMiniHeaders();
        },

        loadSynchroHeaders() {
            return [
                {
                    text: '#',
                    value: 'num',
                },
                {
                    text: 'Execution',
                    value: 'execution',
                },
                {
                    text: 'HD',
                    value: 'hd',
                },
                {
                    text: 'Sync',
                    value: 'sync',
                },
                {
                    text: 'DD',
                    value: 'dd',
                },
                {
                    text: 'ND',
                    value: 'nd',
                    align: 'end',
                },
                {
                    text: 'Score',
                    value: 'score',
                },
            ];
        },

        loadAllAroundHeaders() {
            return [
                {
                    text: 'Trampoline',
                    value: 'trampoline_score',
                },
                {
                    text: 'Double-Mini',
                    value: 'double_mini_score',
                },
                {
                    text: 'Tumbling',
                    value: 'tumbling_score',
                },
            ];
        },
    },
};
